module.exports = "https://www.gc-pro.gnp.com.mx/2636a9a355a5137f84f24457d2175e79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/flecha-arriba-blanco.svg
// module id = 968
// module chunks = 0